export const footerCopy = {
  footer_customize: '自定义',
  footer_site_colours: '主题模式',
  footer_code_font: '代码字体',
  footer_site_colours_options_system: '跟随系统',
  footer_site_colours_options_always_light: '浅色模式',
  footer_site_colours_options_always_dark: '深色模式',
};
